// Verified 2026-08-10: gtag('consent', 'update') confirmed firing on rejection
// in a standard (non-Tag Assistant) session. Audit implicit:true was a
// testing-environment artifact from disconnected Tag Assistant.

// Maps OneTrust non-essential group IDs to GTM Consent Mode v2 type names.
const GROUP_TO_GTM_TYPES = {
    C0002: ['analytics_storage'],
    C0003: ['functionality_storage'],
    C0004: ['ad_storage', 'ad_user_data', 'ad_personalization'],
    C0005: ['personalization_storage'],
}

const NON_ESSENTIAL_GROUPS = Object.keys(GROUP_TO_GTM_TYPES)

function parseActiveGroupsString(s) {
    if (!s || typeof s !== 'string') return []
    return s.split(',').map((g) => g.trim()).filter(Boolean)
}

function handleGtmConsentUpdate(event) {
    if (typeof window.gtag !== 'function') return

    const rawDetail = (event && event.detail) || window.OnetrustActiveGroups || ''
    const consentedGroups = Array.isArray(rawDetail)
        ? rawDetail
        : parseActiveGroupsString(rawDetail)

    const update = { security_storage: 'granted' }

    NON_ESSENTIAL_GROUPS.forEach((group) => {
        const state = consentedGroups.includes(group) ? 'granted' : 'denied'
        GROUP_TO_GTM_TYPES[group].forEach((type) => {
            update[type] = state
        })
    })

    window.gtag('consent', 'update', update)
}

export function initGtmConsentBridge() {
    if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
        window.OneTrust.OnConsentChanged(handleGtmConsentUpdate)
        return
    }

    // Guard against the race where OptanonWrapper fired before this listener
    // was registered. _onetrustReady is set by OptanonWrapper in enqueues.php.
    if (window._onetrustReady) {
        setTimeout(initGtmConsentBridge, 0)
        return
    }

    window.addEventListener('onetrust-ready', initGtmConsentBridge, { once: true })
}
